import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

// Inline Edit/Save/Cancel for the household's primary phone/email (server-enforced access + audit).
export const PrimaryContactEdit = ({ hid, person, choices, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const cur = { phone: person?.phone || "", email: person?.email || "" };
  const open = (pre = {}) => { setForm({ ...cur, ...pre }); setErr(null); setEdit(true); };

  const save = async () => {
    const changes = {}, expected = {};
    ["phone", "email"].forEach((k) => { if ((form[k] || "") !== cur[k]) { changes[k] = form[k]; expected[k] = cur[k] || null; } });
    if (!Object.keys(changes).length) { setEdit(false); return; }
    setBusy(true); setErr(null);
    try { await api.patch(`/agent/households/${hid}/profile`, { changes, expected }); setEdit(false); onSaved && onSaved(); }
    catch (e) { setErr(e?.response?.data?.detail || "Save failed."); }
    finally { setBusy(false); }
  };

  const conflicts = Object.entries(choices || {}).filter(([, v]) => v?.length > 1);
  if (!edit) {
    return (
      <div className="sm:col-span-2 -mt-2" data-testid="primary-contact-edit">
        <Button size="sm" variant="outline" onClick={() => open()} data-testid="primary-contact-edit-btn">Edit contact</Button>
        {conflicts.map(([k, vals]) => (
          <p key={k} className="mt-2 text-xs text-[#92400E]" data-testid={`primary-contact-choices-${k}`}>
            Different {k} values in this household's requests — choose one:{" "}
            {vals.map((v) => <button key={v} className="underline mr-2" onClick={() => open({ [k]: v })} data-testid={`primary-contact-choose-${k}`}>{v}</button>)}
          </p>
        ))}
      </div>
    );
  }
  return (
    <div className="sm:col-span-2 -mt-2 flex flex-col sm:flex-row gap-2 sm:items-center" data-testid="primary-contact-form">
      <input value={form.phone || ""} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone" inputMode="tel"
        className="h-9 rounded-md border px-2 text-sm" data-testid="primary-contact-phone" />
      <input value={form.email || ""} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" type="email"
        className="h-9 rounded-md border px-2 text-sm" data-testid="primary-contact-email" />
      <Button size="sm" onClick={save} disabled={busy} data-testid="primary-contact-save">Save</Button>
      <Button size="sm" variant="ghost" onClick={() => setEdit(false)} data-testid="primary-contact-cancel">Cancel</Button>
      {err && <span className="text-xs text-[#B91C1C]" data-testid="primary-contact-error">{err}</span>}
    </div>
  );
};
